/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-and-after-slider' ).each( function( key, component ) {
        const totalSlides = $( component ).find( '.slide' ).length;
        let slidesToShow = 2;
        if ( window.innerWidth < 1024 ) {
          slidesToShow = 1;
        }
        $( component ).find( '.progress-bar .progress' ).css( 'width', ( ( slidesToShow / totalSlides ) * 100 ) + '%' );

        $( component ).find( '.slider' ).slick( {
          dots: false,
          infinite: false,
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          prevArrow: $( component ).find( '.prev-slide' )[1],
          nextArrow: $( component ).find( '.next-slide' )[1],
          draggable: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                prevArrow: $( component ).find( '.prev-slide' )[0],
                nextArrow: $( component ).find( '.next-slide' )[0],
              },
            },
          ],
        } );

        $( component ).find( '.slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
          $( component ).find( '.progress-bar .progress' ).css( 'width', ( ( ( ( nextSlide ) + slidesToShow ) / totalSlides ) * 100 ) + '%' );
        } );

        // $( this ).find( '.slider' ).magnificPopup( {
        //   type: 'image',
        //   delegate: 'a',
        //   gallery: {
        //     enabled: true,
        //   },
        // } );
      } );

      $( '.before-and-after-slider .image-wrapper .dragger' ).on( 'mousedown touchstart', function() {
        $( this ).closest( '.comparison-slider' ).on( 'mousemove touchmove', function( e ) {
          const offset = $( this ).offset();
          const pos = ( ( e.pageX - offset.left ) / $( this ).find( '.slider-img--2' ).width() ) * 100;
          $( this ).find( '.slider-img--1' ).css( 'clip-path', 'polygon(0% 0%, ' + pos + '% 0%, ' + pos + '% 100%, 0% 100%)' );
          $( this ).find( '.slider-img--2' ).css( 'clip-path', 'polygon(' + pos + '% 0%, 100% 0%, 100% 100%, ' + pos + '% 100%)' );
          $( this ).find( '.dragger' ).css( 'left', e.pageX - offset.left );
        } );
      } ).on( 'mouseup touchend', function() {
        $( '.before-and-after-slider .comparison-slider, .before-and-after-slider .image-wrapper .comparison-slider *' ).off( 'mousemove touchmove' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
